import React from 'react';
import '../../App.css';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import Hobby from './hobby pages/HobbyHome.js';
import Animation from './hobby pages/Animation.js';
import Collection from './hobby pages/Collecting.js';
import Drawing from './hobby pages/Drawing.js';
import Programming from './hobby pages/Programming.js';
import Repairing from './hobby pages/Repairing.js';
import './Hobbies.css'


export default function Hobbies() {
    return ( 
        <Router>
            <Switch>
                <Route path='/DigitalPortfolio/hobbies' exact component={Hobby} />
                <Route path='/DigitalPortfolio/hobbies/Animation' component={Animation} />
                <Route path='/DigitalPortfolio/hobbies/Collection' component={Collection} />
                <Route path='/DigitalPortfolio/hobbies/Drawing' component={Drawing} />
                <Route path='/DigitalPortfolio/hobbies/Programming' component={Programming} />
                <Route path='/DigitalPortfolio/hobbies/Repairing' component={Repairing} />
            </Switch>
        </Router>
        )
}